import {JetView} from "webix-jet"; // Importing JetView class from webix-jet for creating views
import {allpayments} from "models/allpayments"; // Importing allpayments model for data handling
import {devConfig} from "config/config"; // Importing development configuration settings

/**
 * Class representing the view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the user security management interface.
     * @returns {Object} The configuration object for the form.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam("user", true); // Current user ID parameter

        const left = {
            margin: 0,
            id: "a1",
            autoheight: true,
            rows: [
                {
                    margin: 0,
                    css: "on-row",
                    cols:[
                        {
                            view: 'form',
                            margin: 10,
                            minWidth: 200,
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesUserClaveSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesUserClaveSwitch",
                            id: "desbloquearclaveestadoUsuario",
                            rows: [
                                {view: "label", label: _("Desbloquear Usuario por Clave")}, // Label for unlocking user
                                { css: "centrar", id: "UnlockUserByPassword", view: "button", labelWidth:55,value: _("Desbloquear"),
                                    click: () => {
                                        // AJAX request to unlock user by password
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"UnlockUserByPassword","Id":' + cur_user + ',"IsActivate":"A"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                text = JSON.parse(text);
                                                if(text.HasError){
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                }else{
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                }
                                            }
                                        });
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            margin: 10,
                            css: "secutity prm-AdminuserSecurityGeneratePasswordSwitch",
                            id: "generatePassword",
                            hidden:!devConfig.getPermAction("AdminuserSecurityGeneratePasswordSwitch", "Switch"), // Permission check
                            rows: [
                                {view: "label", label: _("Generar contraseña")}, // Label for generating password
                                { css: "centrar", id: "GeneratePassword", view: "button", labelWidth:55,value: _("Generar"),
                                    click: () => {
                                        // AJAX request to generate password
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"GeneratePassword","Id":' + cur_user + ',"IsActivate":"A"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                text = JSON.parse(text);
                                                if(text.HasError){
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                }else{
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                }
                                            }
                                        });
                                    }},
                            ]
                        },
                        {
                            view: 'form',
                            margin: 10,
                            css: "secutity prm-AdminuserSecurityGeneratePassword2Switch",
                            id: "generatePassword",
                            hidden:!devConfig.getPermAction("AdminuserSecurityGeneratePassword2Switch", "Switch"), // Permission check
                            rows: [
                                {view: "label", label: _("Generar contraseña")}, // Label for generating second password
                                { css: "centrar", id: "GeneratePassword2", view: "button", labelWidth:55,value: _("Generar"),
                                    click: () => {
                                        // AJAX request to generate second password
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"GeneratePassword2","Id":' + cur_user + ',"IsActivate":"A"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                text = JSON.parse(text);
                                                if(text.HasError){
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                }else{
                                                    webix.message({title: _("Contraseña cambiada"), type:"alert-warning" ,text:text.Data}); // Success message with new password
                                                }
                                            }
                                        });
                                    }
                                }
                            ]
                        },
                        {
                            view: 'form',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesUserEstadoSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesUserEstadoSwitch",
                            id: "estadoUsuario",
                            rows: [
                                {view: "label", label: _("Estado de Usuario")}, // Label for user status
                                {
                                    css: "centrar",
                                    id: "StateSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change user state
                                        if ($$("StateSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"State","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"State","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesUserPaisSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesUserPaisSwitch",
                            id: "estadoUsuarioPais",
                            rows: [
                                {view: "label", label: _("Usuario es de País")}, // Label for country status
                                {
                                    css: "centrar",
                                    id: "StateCountrySwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change country status
                                        if ($$("StateCountrySwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"StateCountry","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateCountrySwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"StateCountry","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateCountrySwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesUserMandanteSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesUserMandanteSwitch",
                            id: "estadoUsuarioMandante",
                            rows: [
                                {view: "label", label: _("Usuario es Global")}, // Label for global user status
                                {
                                    css: "centrar",
                                    id: "StateMandanteSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change global user status
                                        if ($$("StateMandanteSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"StateMandante","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateMandanteSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"StateMandante","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateMandanteSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesPartnerGlobalSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesPartnerGlobalSwitch",
                            id: "partnerGlobal",
                            rows: [
                                {view: "label", label: _("Partner Global")}, // Label for global partner status
                                {
                                    css: "centrar",
                                    id: "StatePartnerGlobalSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change partner global status
                                        if ($$("StatePartnerGlobalSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"PartnerGlobal","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StatePartnerGlobalSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"PartnerGlobal","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StatePartnerGlobalSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            margin: 10,
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesUserPaisEstadoSwitch", "Switch"), // Permission check
                            id: "estadoUsuarioPais",
                            rows: [
                                {view: "label", label: _("Usuario es de País")}, // Label for country user status
                                {
                                    view: "button", id: "StateBttactivarPais",
                                    value: _("Activar Usuario País"), // Button to activate country user
                                    type: "form",
                                    click: () => {
                                        // AJAX request to activate country user
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"StateCountry","Id":' + cur_user + ',"IsActivate":"A"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                webix.message(_("Cambios Realizados")); // Success message
                                                $$('StateBttactivarPais').hide(); // Hide activate button
                                                $$('StateBttinactivarPais').show(); // Show deactivate button
                                                webix.html.removeCss($$("estadoUsuarioPais").getNode(), "bkgRed"); // Remove red background
                                                webix.html.addCss($$("estadoUsuarioPais").getNode(), "bkgGreen"); // Add green background
                                            }
                                        });
                                    }
                                },
                                {
                                    view: "button",
                                    id: "StateBttinactivarPais",
                                    value: _("Inactivar Usuario País"), // Button to deactivate country user
                                    type: "form",
                                    click: () => {
                                        // AJAX request to deactivate country user
                                        webix.ajax().headers({
                                            "Content-type": "application/json"
                                        }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"StateCountry","Id":' + cur_user + ',"IsActivate":"I"}', {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                webix.message(_("Cambios Realizados")); // Success message
                                                $$('StateBttinactivarPais').hide(); // Hide deactivate button
                                                $$('StateBttactivarPais').show(); // Show activate button
                                                webix.html.removeCss($$("estadoUsuarioPais").getNode(), "bkgGreen"); // Remove green background
                                                webix.html.addCss($$("estadoUsuarioPais").getNode(), "bkgRed"); // Add red background
                                            }
                                        });
                                    }
                                }
                            ]
                        },
                        {gravity:0}
                    ]
                },
                {
                    margin: 0,
                    css: "on-row",
                    cols:[
                        {
                            view: 'form',
                            id: 'Contingency',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyEstadoSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesContingencyEstadoSwitch",
                            rows: [
                                {view: "label", label: _("Estado de Contingencia")}, // Label for contingency status
                                {
                                    id: "StateContingencySwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change contingency status
                                        if ($$("StateContingencySwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencySwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"Contingency","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencySwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            id: "ContingencyDeportivas",
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyDeportivasSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesContingencyDeportivasSwitch",
                            rows: [
                                {view: "label", label: _("Contingencia Deportivas")}, // Label for sports contingency
                                {
                                    id: "StateContingencyDeportivasSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change sports contingency status
                                        if ($$("StateContingencyDeportivasSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyDeportivasSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencySports","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyDeportivasSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            id: 'ContingencyCasino',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyCasinoSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesContingencyCasinoSwitch",
                            rows: [
                                {view: "label", label: _("Contingencia Casino")}, // Label for casino contingency
                                {
                                    id: "StateContingencyCasinoSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change casino contingency status
                                        if ($$("StateContingencyCasinoSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyCasinoSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyCasino","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyCasinoSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            id: 'ContingencyCasinoVivo',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyCasinoVivoSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesContingencyCasinoVivoSwitch",
                            rows: [
                                {view: "label", label: _("Contingencia Casino en Vivo")}, // Label for live casino contingency
                                {
                                    id: "StateContingencyCasinoVivoSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change live casino contingency status
                                        if ($$("StateContingencyCasinoVivoSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyCasinoVivoSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyCasinoVivo","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyCasinoVivoSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {gravity:0}
                    ]
                },
                {
                    margin: 0,
                    css: "on-row",
                    cols:[
                        {
                            view: 'form',
                            id: 'ContingencyVirtuales',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyVirtualesSwitch", "Switch"), // Permission check
                            css: "secutity prm-AdminuserSecurityChangesContingencyVirtualesSwitch",
                            rows: [
                                {view: "label", label: _("Estado de Contingencia Virtuales")}, // Label for virtual contingency status
                                {
                                    id: "StateContingencyVirtualesSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change virtual contingency status
                                        if ($$("StateContingencyVirtualesSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyVirtualesSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyVirtuales","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyVirtualesSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            id: 'ContingencyPoker',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyPokerSwitch", "Switch"), // Permission check
                            css: "secutity prm-",
                            rows: [
                                {view: "label", label: _("Estado de Contingencia Poker")}, // Label for poker contingency status
                                {
                                    id: "StateContingencyPokerSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change poker contingency status
                                        if ($$("StateContingencyPokerSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyPokerSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyPoker","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyPokerSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            id: 'ContingencyRestriccionIP',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyRestriccionIPSwitch", "Switch"), // Permission check
                            css: "secutity prm-",
                            rows: [
                                {view: "label", label: _("Restricción IP")}, // Label for IP restriction
                                {
                                    view: "text", name: "IP", id: "IP",
                                    label: _("IP"), labelPosition: "top",
                                    placeholder: _("IP") // Placeholder for IP input
                                },
                                {
                                    id: "StateContingencyRestriccionIPSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change IP restriction status
                                        if ($$("StateContingencyRestriccionIPSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyRestriccionIP","Id":' + cur_user + ',"IsActivate":"A","IP":"' + $$('IP').getValue() + '"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyRestriccionIPSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyRestriccionIP","Id":' + cur_user + ',"IsActivate":"I","IP":"' + $$('IP').getValue() + '"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyRestriccionIPSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            id: 'ContingencyTokenGoogle',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyTokenGoogleSwitch", "Switch"), // Permission check
                            css: "secutity prm-",
                            rows: [
                                {view: "label", label: _("Token Google")}, // Label for Google token
                                {
                                    id: "StateContingencyTokenGoogleSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change Google token status
                                        if ($$("StateContingencyTokenGoogleSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyTokenGoogle","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyTokenGoogleSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyTokenGoogle","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type: "alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyTokenGoogleSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {gravity:0}
                    ]
                },
                {
                    margin: 0,
                    css: "on-row",
                    cols:[
                        {
                            view: 'form',
                            id: 'ContingencyTokenLocal',
                            hidden: !devConfig.getPermAction("AdminuserSecurityChangesContingencyTokenLocalSwitch", "Switch"), // Permission check
                            css: "secutity prm-",
                            rows: [
                                {view: "label", label: _("Token Local")}, // Label for local token
                                {
                                    id: "StateContingencyTokenLocalSwith",
                                    view: "switch",
                                    labelWidth: 55,
                                    onLabel: _("Activo"), // Label for active state
                                    offLabel: _("Inactivo"), // Label for inactive state
                                    click: () => {
                                        // AJAX request to change local token status
                                        if ($$("StateContingencyTokenLocalSwith").getValue() == 1) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyTokenLocal","Id":' + cur_user + ',"IsActivate":"A"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyTokenLocalSwith").setValue(1); // Set switch to active
                                                }
                                            });
                                        } else {
                                            webix.ajax().headers({
                                                "Content-type": "application/json"
                                            }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", '{"Action":"ContingencyTokenLocal","Id":' + cur_user + ',"IsActivate":"I"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Cambios Realizados")); // Success message
                                                    $$("StateContingencyTokenLocalSwith").setValue(0); // Set switch to inactive
                                                }
                                            });
                                        }
                                    }
                                },
                            ]
                        },
                        {
                            view: 'form',
                            id: 'IsCancelAdminAccount',
                            hidden: !devConfig.getPermAction("AdminuserSecurityCancelAccountSwitch", "Switch"), // Permission check
                            css: "secutity prm-",
                            rows: [
                                {
                                    view: "button",
                                    id: "StateCancelAdminAccountSwith",
                                    name: "StateCancelAdminAccountSwith",
                                    label: _("Cancelar cuenta"),
                                    labelPosition: "center",
                                    css: "labelCancelAccount",
                                    click: () => {
                                        webix.ui({
                                            view: "window",
                                            head: {
                                                view: "toolbar",
                                                cols: [
                                                    { view: "label", label: _("Desea realizar movimiento?") }
                                                ]
                                            },
                                            position: "center",
                                            modal: true,
                                            body: {
                                                view: "form", id: "formCancelAccount", elements: [
                                                    { view: "text", label: _("Observación"), name: "Note", required: false, labelWidth: 100 },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "button", value: _("Cancelar"), click: function () {
                                                                    this.getTopParentView().hide();
                                                                    $$('formCancelAccount').setValues($$('formCancelAccount').getCleanValues());
                                                                    $$('StateCancelAdminAccountSwith').setValue(0)
                                                                }
                                                            },
                                                            {
                                                                view: "button", type: "form", value: _("Guardar"), click: function () {
                                                                    if ($$("formCancelAccount").validate()) {
                                                                        var valuesForm = $$("formCancelAccount").getValues();
                                                                        webix.ajax().headers({
                                                                            "Content-type": "application/json"
                                                                        }).post(devConfig.geturlApi() + "Client/UpdateUserSecurity", JSON.stringify({
                                                                            Action: "IsCancelAdminAccount",
                                                                            Id: cur_user,
                                                                            IsActivate: "A",
                                                                            Note: valuesForm.Note
                                                                        }), {
                                                                            error: function (text, data, XmlHttpRequest) {
                                                                                webix.message({ title: _("¡Error!"), type: "alert-error", text: _("Ocurrio un error.") });
                                                                                $$('StateCancelAdminAccountSwith').setValue(0)
                                                                            },
                                                                            success: function (text, data, XmlHttpRequest) {
                                                                                var data = JSON.parse(text);
                                                                                if (!data.HasError) {
                                                                                    webix.message(_("Cambios Realizados"));
                                                                                } else {
                                                                                    webix.message({ title: _("¡Error!"), type: "alert-error", text: _("Ocurrio un error.") });
                                                                                    $$('StateCancelAdminAccountSwith').setValue(0)
                                                                                }
                                                                                $$("formCancelAccount").getTopParentView().hide();
                                                                            }
                                                                        });
                                                                    } else {
                                                                        webix.message({
                                                                            title: _("¡Error!"),
                                                                            type: "alert-error",
                                                                            text: _("Completa los campos...")
                                                                        });
                                                                        $$('StateCancelAdminAccountSwith').setValue(0)
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ],
                                                elementsConfig: {
                                                    on: {
                                                        onChange: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            }
                                        }).show();
                                    }
                                }
                            ]
                        },
                        {id: "grav2", gravity:2},
                        {gravity:0}
                    ]
                },
            ]
        };

        const upper_section = {
            height: (document.body.offsetWidth < 500) ? 1880 : 0, // Adjust height based on screen width
            css: "secutity prm-",
            rows:[{
                margin: 10,
                cols: [
                    left // Left section containing forms and buttons
                ]
            }]
        };

        return {
            view: "form",  id: 'myForm',
            rows: [
                upper_section // Main form structure
            ],
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for form fields
            }
        };
    }
    // Configuration function placeholder for setting up the view's UI components

    /**
     * Initializes the grid with user-specific data.
     * @param {Object} grid - The grid object to be initialized.
     */
    init(grid) {
        // Retrieve the current user parameter from the URL.
        const cur_user = this.getParam("user", true);

        // Add custom CSS styles for background colors.
        webix.html.addStyle(".bkgRed{ background:rgba(255, 0, 0, 0.5803921568627451) !important; }");
        webix.html.addStyle(".bkgGreen{ background:rgba(3, 199, 3, 0.35) !important; }");

        // Make an AJAX GET request to fetch client data by user ID.
        webix.ajax().get(devConfig.geturlApi() + "Client/GetClientSpById", 'id=' + cur_user, {
            // Handle error response from the AJAX request.
            error: function (text, data, XmlHttpRequest) {
                webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")});
            },
            // Handle successful response from the AJAX request.
            success: function (text, data, XmlHttpRequest) {
                // Parse the JSON response text.
                text = JSON.parse(text);

                // Set the IP value in the corresponding UI element.
                $$('IP').setValue(text[0].IP);

                // Set the state of various switches based on the response data.
                if (text[0].IsActivate == "A") {
                    $$("StateSwith").setValue(1);
                } else {
                    $$("StateSwith").setValue(0);
                }
                if (text[0].IsActivateContingency == "A") {
                    $$("StateContingencySwith").setValue(1);
                } else {
                    $$("StateContingencySwith").setValue(0);
                }
                if (text[0].IsActivateContingencyDeportivas == "A") {
                    $$("StateContingencyDeportivasSwith").setValue(1);
                } else {
                    $$("StateContingencyDeportivasSwith").setValue(0);
                }
                if (text[0].IsActivateContingencyCasino == "A") {
                    $$("StateContingencyCasinoSwith").setValue(1);
                } else {
                    $$("StateContingencyCasinoSwith").setValue(0);
                }
                if (text[0].IsActivateContingencyCasinoVivo == "A") {
                    $$("StateContingencyCasinoVivoSwith").setValue(1);
                } else {
                    $$("StateContingencyCasinoVivoSwith").setValue(0);
                }
                if (text[0].IsActivateContingencyVirtuales == "A") {
                    $$("StateContingencyVirtualesSwith").setValue(1);
                } else {
                    $$("StateContingencyVirtualesSwith").setValue(0);
                }
                if (text[0].IsActivateContingencyPoker == "A") {
                    $$("StateContingencyPokerSwith").setValue(1);
                } else {
                    $$("StateContingencyPokerSwith").setValue(0);
                }
                if (text[0].IsRestrictionIP == "A") {
                    $$("StateContingencyRestriccionIPSwith").setValue(1);
                } else {
                    $$("StateContingencyRestriccionIPSwith").setValue(0);
                }
                if (text[0].IsTokenGoogle == "A") {
                    $$("StateContingencyTokenGoogleSwith").setValue(1);
                } else {
                    $$("StateContingencyTokenGoogleSwith").setValue(0);
                }
                if (text[0].IsTokenLocal == "A") {
                    $$("StateContingencyTokenLocalSwith").setValue(1);
                } else {
                    $$("StateContingencyTokenLocalSwith").setValue(0);
                }
                if (text[0].UserCountry == "S") {
                    $$("StateCountrySwith").setValue(1);
                } else {
                    $$("StateCountrySwith").setValue(0);
                }
                if (text[0].UserGlobal == "S") {
                    $$("StateMandanteSwith").setValue(1);
                } else {
                    $$("StateMandanteSwith").setValue(0);
                }
                if (text[0].PartnerGlobal == "S") {
                    $$("StatePartnerGlobalSwith").setValue(1);
                } else {
                    $$("StatePartnerGlobalSwith").setValue(0);
                }

                // Log the response data to the console for debugging purposes.
                console.log(text);
            }
        });
    }
    // Initialization function placeholder for setting up event handlers and data loading
}

// FILE DOCUMENTED
